import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JhiEventManager } from 'ng-jhipster';
import { isUndefined } from 'util';

import { Account, Faculty, User } from '../../../models';
import { FacultyService, UserService, Principal } from '../../../services';
import { checkIfCanDelete, checkIfCanEdit } from '../../../shared';
import { USER_LIST_MODIFICATION } from '../../../shared/constants';
import { HumanAuthorities } from '../../../shared/enums';

// TODO: Check compatibility with server authentication

@Component({
    selector: 'qms-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./users.component.css']
})
export class UserDetailsComponent implements OnInit, OnDestroy {

    private currentAccount: Account;

    public user: User;
    public username: string;
    public accessDenied: boolean;

    public faculties: Faculty[];

    private routeDataSubscription: Subscription;
    private routerSubscription: Subscription;
    private userSubscription: Subscription;

    constructor(private principal: Principal,
                private userService: UserService,
                private facultyService: FacultyService,
                private activatedRoute: ActivatedRoute,
                private eventManager: JhiEventManager) {
        this.accessDenied = false;
        this.routeDataSubscription = this.activatedRoute.data.subscribe((data: any) => {
            this.routerSubscription = this.activatedRoute.params.subscribe((params: any) => {
                this.username = params['username'];
                this.loadUser();
            });
        });
    }

    ngOnInit() {
        this.principal.identity().then((account: Account) => {
            this.currentAccount = account;
            this.registerChangeInUsers();
        });
    }

    ngOnDestroy() {
        this.routeDataSubscription.unsubscribe();
        this.routerSubscription.unsubscribe();
        this.userSubscription.unsubscribe();
    }

    private loadUser() {
        this.user = null;
        this.userService.find(this.username).subscribe((user: User) => {
            this.accessDenied = false;
            user.authorities.forEach((authority) => {
                if (isUndefined(HumanAuthorities[authority])) {
                    this.accessDenied = true;
                }
            });
            this.user = user;
            this.faculties = [];
            this.user.faculties.forEach((facultyId: number) => {
                this.facultyService.find(facultyId).subscribe((faculty: Faculty) => {
                    this.faculties.push(faculty);
                });
            });
        });
    }

    private registerChangeInUsers() {
        this.userSubscription = this.eventManager.subscribe(USER_LIST_MODIFICATION, () => this.loadUser());
    }

    public previousState() {
        window.history.back();
    }

    public canDelete(user: User): boolean {
        return checkIfCanDelete(user, this.currentAccount);
    }

    public canEdit(user: User): boolean {
        return checkIfCanEdit(user, this.currentAccount);
    }

    public isLoggedUser(user: User): boolean {
        return (user.login === this.currentAccount.login);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/users/user-details.component.ts